import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const retryTaskGroup = async (model: IUnitTaskGroupModel): Promise<IUnitTaskGroupModel> =>
  axios.post(`/management/UnitProgramTask/RetryTaskGroup`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskGroupModel
}

export const useManagementRetryTaskGroup = (notify?: boolean, onSuccess?: (data: IUnitTaskGroupModel) => void) =>
  useMutation({
    mutationKey: ['retryTaskGroup'],
    mutationFn: ({ model }: Props) => retryTaskGroup(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated task.')
      }
    },
    onError: (e) => {
      if (notify) {
        toastError(e?.message || 'Failed to update task.')
      }
    },
    throwOnError: false
  })
